// AUTO GENERATED FILE - Changes WILL be lost.
// id - used as 'id' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Betslip",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Pasang taruhan",
  "betslip.clear": "Hapus semua",
  "betslip.clearResult": "Hapus",
  "betslip.noSelections": "Tambahkan pilihan untuk memulai taruhan",
  "betslip.notLoggedIn": "Login untuk mulai taruhan",
  "betslip.refresh": "Refresh",
  "betslip.totalStake": "Total taruhan",
  "betslip.noHistoryData": "Tidak ada informasi taruhan yang tersedia",
  "betslip.openBets": "Taruhan Terbuka",
  "betslip.betHistory": "History Taruhan",
  "betslip.betHistoryWon": "Menang",
  "betslip.betHistoryLost": "Kalah",
  "loading.loading": "Memuat",
  "loading.account": "Memuat akun",
  "loading.league": "Memuat liga",
  "loading.gameweeks": "Memuat game week",
  "loading.markets": "Memuat pasar",
  "loading.bethistory": "Memuat history taruhan",
  "login.loginRequired": "Silakan Login",
  "login.loginToBet": "Silakan Login untuk mulai taruhan",
  "navigation.back": "Kembali",
  "navigation.close": "Tutup",
  "video.liveStreamAvailable": "Streaming live tersedia",
  "video.logInToWatch": "Silakan login untuk menyaksikan",
  "error.error": "Kesalahan",
  "error.404": "halaman tidak ditemukan",
  "error.gameLaunchFailed": "Tidak dapat meluncurkan game",
  "error.unknownErrorCode": "Kesalahan yang tidak diketahui: {code}",
  "error.minUnitStakeLimitExceeded": "Minimum taruhan adalah {limit}",
  "error.maxUnitStakeLimitExceeded": "Maksimum taruhan adalah {limit}",
  "error.minTotalStakeLimitExceeded": "Minimum total taruhan adalah {limit}",
  "error.maxTotalStakeLimitExceeded": "Maksimum total taruhan adalah {limit}",
  "error.notPlaced": "Tidak terpasang",
  "error.wagerDisallowed": "Taruhan tidak diperbolehkan",
  "error.errorEventIsOff": "Event telah dimulai",
  "wagerType.Singles": "Singles",
  "wagerType.Doubles": "Doubles",
  "wagerType.Trebles": "Trebles",
  "wagerType.Accumulator": "Accumulator",
  "wagerType.Perm 4-Folds": "Perm 4-Folds",
  "wagerType.Perm 5-Folds": "Perm 5-Folds",
  "wagerType.Perm 6-Folds": "Perm 6-Folds",
  "wagerType.Perm 7-Folds": "Perm 7-Folds",
  "wagerType.Perm 8-Folds": "Perm 8-Folds",
  "wagerType.Perm 9-Folds": "Perm 9-Folds",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Tidak ada lagi taruhan",
  "playtime": "Waktu bermain",
  "gameId": "Game ID",
  "noGames": "Tidak ada game tersedia. Cek kembali nanti.",
  "Home": "Home",
  "Away": "Away",
  "Visitor": "Tamu",
  "soccerbet.gameWeek": "GAMEWEEK",
  "soccerbet.noGameWeeks": "Tidak ada game week yang tersedia. Silakan cek kembali nanti.",
  "soccerbet.league": "Klasemen Liga",
  "soccerbet.table.name": "Nama",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "D",
  "soccerbet.table.lost": "L",
  "soccerbet.table.points": "PT",
  "selection.Yes": "Ya",
  "selection.No": "Tidak",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Ya",
  "selection.1+No": "1+Tidak",
  "selection.X+Yes": "X+Ya",
  "selection.X+No": "X+Tidak",
  "selection.2+Yes": "2+Ya",
  "selection.2+No": "2+Tidak",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN"
}
